import { parseDocument } from 'htmlparser2';

// composables/useRichTextFormatter.ts
export const useSanitisedRichText = () => {
    /**
     * Strips HTML formatting from Storyblok's RichText content using htmlparser2
     * @param {string} richText - The RichText content (HTML string) from Storyblok
     * @returns {string} Plain text without any HTML tags
     */
    const stripFormatting = (richText: string): string => {
        if (!richText) return '';

        // Parse the HTML content
        const doc = parseDocument(richText);

        // Recursively extract text content from the parsed document
        const getText = (node): string => {
            if (node.type === 'text') return node.data;
            return node.children?.map(getText).join('') || '';
        };

        return getText(doc);
    };

    return {
        stripFormatting,
    };
};
